export const OTHER_SOURCE_OF_WEALTH = "4";
export const SOURCE_OF_CAPITAL_WEALTH_LABEL = "Source of capital/wealth";
